import React from 'react';
import { NavLink } from 'react-router-dom';
import PillButton from '../components/PillButton';
import SEO from '../components/SEO';

function Home() {
  return (
    <div>
      <SEO 
        title="The Code-E Project | Learn Frontend Web Development"
        description="Welcome to The Code-E Project - A comprehensive resource for learning HTML, CSS, JavaScript, Bootstrap and more with a sleek black-and-white design."
        keywords="frontend development, web development, HTML, CSS, JavaScript, Bootstrap, beginner friendly, coding tutorials"
      />
      
      {/* Hero Section */}
      <section className="hero-section text-center">
        <div className="container">
          <h1>Empower Your Career with Web Development</h1>
          <p className="lead">
            A comprehensive, professional guide to mastering the fundamentals of modern frontend development.
          </p>
          <NavLink to="/html">
            <PillButton className="mt-3">Start Learning</PillButton>
          </NavLink>
        </div>
      </section>

      {/* Additional Content for Students */}
      <main>
        <section className="container">
          <h2>Build a Strong Foundation for Your Future</h2>
          <p>
            This platform is designed for dedicated learners seeking a structured path to web development mastery. 
            We provide clear, in-depth resources focusing on semantic HTML, accessible design, and clean code principles. 
            Explore the essentials like <b>&lt;header&gt;</b> and <b>&lt;main&gt;</b>, then advance to complex layouts and interactions. 
            This is your toolkit for building professional-grade websites and advancing your technical skills. Let's begin your journey 
            into the industry.
          </p>

          <div className="row mt-4">
            <div className="col-md-6 mb-4">
              <h3>HTML: Structure Your Content</h3>
              <p>
                Learn to use HTML to create the backbone of any webpage. Understand tags, attributes, and semantic markup to make your sites accessible and SEO-friendly.
              </p>
              <NavLink to="/html">
                <PillButton>Explore HTML</PillButton>
              </NavLink>
            </div>
            <div className="col-md-6 mb-4">
              <h3>CSS: Style with Precision</h3>
              <p>
                Master CSS to control layout, colors, and typography. Dive into flexbox, grid, and custom properties to design visually appealing interfaces.
              </p>
              <NavLink to="/css">
                <PillButton>Explore CSS</PillButton>
              </NavLink>
            </div>
            <div className="col-md-6 mb-4">
              <h3>JavaScript: Add Interactivity</h3>
              <p>
                Use JavaScript to bring your pages to life. Learn variables, functions, and events to create dynamic, user-friendly experiences.
              </p>
              <NavLink to="/javascript">
                <PillButton>Explore JavaScript</PillButton>
              </NavLink>
            </div>
            <div className="col-md-6 mb-4">
              <h3>Bootstrap: Build Faster</h3>
              <p>
                Leverage Bootstrap's grid system and components to streamline development. Customize it, as done here, to match your unique style.
              </p>
              <NavLink to="/bootstrap">
                <PillButton>Explore Bootstrap</PillButton>
              </NavLink>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}

export default Home;